module.exports = __webpack_public_path__ + "static/com_2-a4e86a8ba8d2f46e9e9fabc83262b40e.png";